import { render, staticRenderFns } from "./InfoSideBar.vue?vue&type=template&id=16761a30&scoped=true&"
import script from "./InfoSideBar.vue?vue&type=script&lang=js&"
export * from "./InfoSideBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoSideBar.vue?vue&type=style&index=0&id=16761a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16761a30",
  null
  
)

export default component.exports